// The last appendices picked in the "Reference an appendix" modal, per codesheet and per browser.
// Purely a convenience: storage may be unavailable, so every access is guarded.

export const MAX_RECENT_APPENDIX_PICKS = 3

function storageKey(codeIndexId: string): string {
  return `codesheet:${codeIndexId}:recent-appendix-refs`
}

export function getRecentAppendixPicks(codeIndexId: string | null | undefined): string[] {
  if (!codeIndexId) return []
  try {
    const raw = window.localStorage.getItem(storageKey(codeIndexId))
    const parsed = raw ? JSON.parse(raw) : []
    if (!Array.isArray(parsed)) return []
    return parsed.filter((key): key is string => typeof key === 'string' && key.trim().length > 0).slice(0, MAX_RECENT_APPENDIX_PICKS)
  } catch {
    return []
  }
}

export function pushRecentAppendixPick(codeIndexId: string | null | undefined, key: string): string[] {
  if (!codeIndexId || !key) return getRecentAppendixPicks(codeIndexId)
  const next = [key, ...getRecentAppendixPicks(codeIndexId).filter(existing => existing !== key)].slice(0, MAX_RECENT_APPENDIX_PICKS)
  try {
    window.localStorage.setItem(storageKey(codeIndexId), JSON.stringify(next))
  } catch {
    // Storage is a convenience only.
  }
  return next
}
